import moment from "moment";
import StatBox from "pages/Analytics/elements/StatBox";
import { useLoansQuery } from "modules/loan/queries/use-loans-query";

const LoansCreatedCount = () => {
  const { data: loans = [] } = useLoansQuery();

  const filteredLoans = loans.filter(loan => {
    const loanDate = new Date(loan.created_at);
    const thirtyDaysAgo = moment().subtract(30, "days").toDate();
    return loanDate >= thirtyDaysAgo && loanDate <= new Date();
  });

  return (
    <StatBox title="New Loans" stat={filteredLoans.length} description="in the last 30 days" />
  );
};

export default LoansCreatedCount;
